import * as a from "react";
import n from "../lib/IconBase.es.js";
import t from "../defs/CalendarBlank.es.js";
const e = a.forwardRef((o, r) => /* @__PURE__ */ a.createElement(n, { ref: r, ...o, weights: t }));
e.displayName = "CalendarBlankIcon";
const c = e;
export {
  c as CalendarBlank,
  e as CalendarBlankIcon
};
